import type { ReactNode } from 'react';

import { Illustration } from '@mint-lib/illustrations';
import { typographyVariants } from '@mint-lib/tw-components';

type Props = {
  header: ReactNode;
  message: ReactNode;
};

const NoData = ({ header, message }: Props) => {
  return (
    <div className="flex h-[calc(100vh-350px)] flex-col items-center justify-center">
      <div className="flex flex-col items-center">
        <Illustration className="size-40" component="IllustrationNoResults" />

        <h4 className={typographyVariants({ variant: 'h4', color: 'primary' })}>
          {header}
        </h4>
        <p
          className={typographyVariants({
            variant: 'bodyShort01',
            color: 'secondary',
            className: 'overflow-hidden break-words',
          })}
        >
          {message}
        </p>
      </div>
    </div>
  );
};

export default NoData;
